import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { base64ToBlob } from "../../../../utils";
import { getPDFByAssessment } from "../../../../app/patientSlice";

export const usePdfDownload = () => {
  const dispatch = useDispatch();
  const { patientId } = useParams();

  const patientData = useSelector((state) => state.patient.detailViewData);

  const [pdfLoading, setPdfLoading] = useState(false);

  const handleDownloadPDF = async (id) => {
    setPdfLoading(true);
    const payload = { ne1Id: patientId, graph: null, assessmentid: id, photo: 0 };
    const response = await dispatch(getPDFByAssessment(payload));
    if (response?.pdfData) {
      const blob = base64ToBlob(response.pdfData);
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `Wound_Evaluation_${patientData?.firstName}_${patientData?.lastName}_${id}`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(url);
      setPdfLoading(false);
      toast.success("PDF Downloaded Successfully", { containerId: "warning" });
    }
  };

  return {
    pdfLoading,
    handleDownloadPDF,
  };
};
